import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpErrorInterceptor } from './shared/interceptor/http-error.interceptor';
import { AuthInterceptor } from './shared/interceptor/auth.interceptor';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { CollegeAdminComponent } from './college-admin/college-admin.component';
import { NgIdleModule } from '@ng-idle/core';
import { SharedModule } from './shared/shared.module';
import { TenantInterceptor } from './shared/interceptor/tenant.interceptor';
import { RedirectHandlerComponent } from './redirect-handler/redirect-handler.component';
import { UserVerificationComponent } from './user-verification/user-verification.component';
import { NgOtpInputModule } from 'ng-otp-input';
import * as Sentry from '@sentry/angular';
import { Router } from '@angular/router';
import { AccessTokenInterceptor } from './shared/interceptor/refresh-token.interceptor';
import { EnvSwitcherComponent } from './shared/component/env-switcher/env-switcher.component';
@NgModule({ declarations: [
        AppComponent,
        CollegeAdminComponent,
        RedirectHandlerComponent,
        UserVerificationComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDocViewerModule,
        ToastrModule.forRoot({
            timeOut: 4000,
            preventDuplicates: true,
            maxOpened: 1,
        }),
        NgIdleModule.forRoot(),
        SharedModule,
        NgOtpInputModule,
        EnvSwitcherComponent], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TenantInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpErrorInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AccessTokenInterceptor,
          multi: true,
        },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: PublicHttpInterceptor,
        //     multi: true,
        // },
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler(),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
